import { styled } from 'styled-components'

import { Typography } from '@b-stock/fe-core/design-system'

// Chromeless text-button base shared by the Watchlist bulk-selection
// controls (Select all/Deselect all/Done, Clear selection, Undo) — each
// consumer only differs on color.
export const WatchlistTextButton = styled.button`
  ${Typography.Body3_Semibold}
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`
